export interface Project {
  id: string;
  slug: string;
  title: string;
  category: 'ppf' | 'ceramic' | 'tinting';
  shortDescription: string;
  description: string;
  fullDescription: string;
  images: {
    before: string;
    after: string;
    gallery?: string[];
  };
  alt: string;
  metaTitle?: string;
  metaDescription?: string;
  keywords?: string[];
  serviceLink: string;
  ctaLink: string;
  ctaFormLink: string;
  tags: string[];
  year?: number;
  publishedDate?: string;
  clientName?: string;
}



export const projects: Project[] = [
  {
    id: 'bmw-m4-ppf',
    slug: 'bmw-m4-ppf',
    title: 'BMW M4 – täiskate PPF',
    category: 'ppf',
    shortDescription:
      'Täiskate PPF kiletamine BMW M4-l. Pehme läige, nähtamatu pinnakate ja tugev kaitse Eesti teeolude eest.',
    description:
      'Täiskate PPF kiletamine kapotil, tiibadel ja uste esiosal. CarPro Immortal tagab kaitsva kihi, mis säilitab BMW M4 originaalse säre.',
    fullDescription:
      '<p>BMW M4 omanik soovis täielikku kaitset kahjustuste, kivitäkete ja soolapiiskade eest. Paigaldasime CarPro Immortal PPF kilet täiskatteks – kapotile, esitiibadele, ustele, luugile ja tagumisele tiivale.</p><p>PPF on olnud valitud tänu oma tugevusele ja nähtamatusele. Meie töö tagas auto originaalse läike ning vähendas sõiduki pinnakahjustuste riski, säilitades samas luksusliku viimistluse.</p><p>Tulemus: auto on nähtamatult kaitstud, värv püsib särav ja hooldamine on oluliselt mugavam.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/cd/12/3e/cd123edb1952c1b6e6c356b4b7921074.jpg',
      after: 'https://i.pinimg.com/736x/1b/9d/ef/1b9def78f63e3e3497aa692ba5fee8de.jpg',
      gallery: [
        'https://i.pinimg.com/1200x/aa/5b/e3/aa5be3af8af67aae3da2c90f58633467.jpg',
        'https://i.pinimg.com/1200x/26/39/0b/26390b73de0a55bcdc571505c4bf339d.jpg',
        'https://i.pinimg.com/736x/c2/c2/bb/c2c2bb0b3cee0791a6f3390188530bf2.jpg',
      ],
    },
    alt: 'BMW M4 PPF kaitsekile enne ja pärast',
    metaTitle: 'BMW M4 PPF kaitsekile – näide meie tööst | PPF Garage',
    metaDescription:
      'Vaata BMW M4 täiskate PPF kiletamise tulemust. Töödeldud CarPro Immortaliga, kaitseb kivitäkete ja soola eest.',
    keywords: ['BMW M4', 'PPF', 'täiskate', 'kaitsekile', 'CarPro Immortal'],
    serviceLink: '/teenused/kaitsekiletamine-ppf',
    ctaLink: '/kontakt?service=ppf',
    ctaFormLink: '/kontakt?service=ppf',
    tags: ['PPF', 'BMW', 'M4', 'täiskate', 'CarPro', 'premium'],
    year: 2024,
    publishedDate: '2025-06-15',
    clientName: 'BMW M4 omanik',
  },
  {
    id: 'audi-rs6-ceramic',
    slug: 'audi-rs6-ceramic',
    title: 'Audi RS6 – keraamiline kaitse',
    category: 'ceramic',
    shortDescription:
      'CarPro Quartz Pro 2020 keraamiline kaitse Audi RS6-le. Sügav sära, veehülgavus ja vastupidavus.',
    description:
      'CarPro Quartz Pro 2020 keraamiline kaitse tagab RS6-le tugevama pinna ja sügavama läike. Ideaalselt sobib Eesti ilmastiku jaoks.',
    fullDescription:
      '<p>Audi RS6 omanik soovis auto pinda parandada ning kaitsta seda kemikaalide, soola ja UV-kiirguse eest. Paigaldasime CarPro Quartz Pro 2020 keraamilise kaitse, mis annab vastupidava ja kergesti puhastatava pinnakihi.</p><p>Keraamiline kiht tekitab veehelbed kiiresti pinnalt, vähendab mustuse kinni jäämist ja aitab säilitada värvi sügavust. Samuti parandab see väikeste kriimustuste taluvust ja lihtsustab igapäevast autotöötlemist.</p><p>Tulemus: sügav läige, vastupidav kaitse ning auto välimuse pikaajaline säilimine.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/85/5c/c9/855cc918a3dc1e8da99a9eb826a86d3c.jpg',
      after: 'https://i.pinimg.com/736x/0d/64/ba/0d64ba3cacb32d355b85ccce2af3311d.jpg',
      gallery: [
        'https://i.pinimg.com/1200x/fe/a1/44/fea14431696aeb84d554dea82161b5b6.jpg',
        'https://i.pinimg.com/1200x/2e/2e/4d/2e2e4d54b657bbac1ef122e2cfa3e107.jpg',
        'https://i.pinimg.com/736x/c2/c2/bb/c2c2bb0b3cee0791a6f3390188530bf2.jpg'
      ],
    },
    alt: 'Audi RS6 keraamiline kaitse enne ja pärast',
    metaTitle: 'Audi RS6 keraamiline kaitse – näide | PPF Garage',
    metaDescription:
      'Vaata Audi RS6 keraamilise kaitse tulemust CarPro Quartz Pro 2020-ga. Sügav läige ja UV-kaitse.',
    keywords: ['Audi RS6', 'keraamiline kaitse', 'CarPro Quartz Pro', 'läige', 'UV-kaitse'],
    serviceLink: '/teenused/keraamiline-kaitse',
    ctaLink: '/kontakt?service=ceramic',
    ctaFormLink: '/kontakt?service=ceramic',
    tags: ['keraamiline kaitse', 'Audi', 'RS6', 'CarPro', 'läige'],
    year: 2024,
    publishedDate: '2025-07-01',
    clientName: 'Audi RS6 omanik',
  },
  {
    id: 'mercedes-gle-tinting',
    slug: 'mercedes-gle-tinting',
    title: 'Mercedes GLE – klaaside toonimine',
    category: 'tinting',
    shortDescription:
      'Professionaalne klaaside toonimine Mercedes GLE-le. Sügavam privaatsus ja kaitse UV-kiirguse eest.',
    description:
      'Mercedes GLE sai efektiivse klaaside toonimise, mis tõstab privaatsust ja kaitseb salongi UV-kiirguse eest. Soovitatav linnatingimuste jaoks.',
    fullDescription:
      '<p>Mercedes GLE omanik soovis privaatsust ning paremat kaitset päikese, kuumuse ja UV-kiirguse eest. Paigaldasime tooni kiled, mis vastavad Eesti ohutusstandarditele ja säilitavad hea nähtavuse.</p><p>Protsess oli täpne, alustades klaasi ettevalmistusest ja lõpetades täpse kinnitusega. Lõpptulemus on professionaalne, elegantne ja põhjalikult realiseeritud.</p><p>Tulemus: tumedam visuaal, paremad sõidutingimused ja kaitse salongi sisustuse vähenenud kulumise eest.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/c1/a3/07/c1a30720bfb0cfb064ded378b32f6c9e.jpg',
      after: 'https://i.pinimg.com/736x/36/62/3f/36623f8e2ff3dee261328afb90efb283.jpg',
      gallery: [
        'https://i.pinimg.com/1200x/26/da/69/26da692be7139785234636033115579a.jpg',
        'https://i.pinimg.com/1200x/e3/da/03/e3da036f9e5895d36d3c2954079c65e4.jpg',
        'https://i.pinimg.com/736x/c2/c2/bb/c2c2bb0b3cee0791a6f3390188530bf2.jpg'
      ],
    },
    alt: 'Mercedes GLE klaaside toonimine enne ja pärast',
    metaTitle: 'Mercedes GLE klaaside toonimine – PPF Garage',
    metaDescription:
      'Tutvuge Mercedes GLE klaaside toonimise tulemusega. Privaatsus ja UV-kaitse koos kaasaegse kujundusega.',
    keywords: ['Mercedes GLE', 'klaaside toonimine', 'UV-kaitse', 'privaatsus'],
    serviceLink: '/teenused/klaaside-toonimine',
    ctaLink: '/kontakt?service=tinting',
    ctaFormLink: '/kontakt?service=tinting',
    tags: ['toonimine', 'Mercedes', 'GLE', 'UV-kaitse', 'privaatsus'],
    year: 2024,
    publishedDate: '2025-08-10',
    clientName: 'Mercedes GLE omanik',
  },
  {
    id: 'porsche-911-premium-kaitse',
    slug: 'porsche-911-premium-kaitse',
    title: 'Porsche 911 – täiskate PPF + keraamiline kaitse',
    category: 'ppf',
    shortDescription:
      'Premium-kombinatsioon PPF ja keraamilise kaitsega Porsche 911-le. Maksimaalne sära ja vastupidavus.',
    description:
      'Porsche 911 sai täiskatte PPF ja keraamilise kaitse kombinatsiooni, mis tagab topsa ja püsiva sära ka Eesti oludes.',
    fullDescription:
      '<p>Porsche 911-le paigaldasime esmalt täiskatte PPF kilega ning seejärel lisasime keraamilise kaitsekihina täiendava barjääri. See kombinatsioon annab auto pinnale maksimaalse kaitse nii kivitäkete kui ka kemikaalide eest.</p><p>PPF säilitab auto originaalse kujundi ja läike, samas kui keraamiline kaitse parandab veehelbeid ning hõlbustab pesemist. Tulemuseks on nutikas, esteetiline ja vähem hooldust vajav pind.</p><p>Tulemus: Porsche särab intensiivselt, samal ajal on pind kaitstud pikaaegsete kahjustuste eest.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/ce/ec/c0/ceecc0a6958a3211ba31ccbd8bf66eda.jpg',
      after: 'https://i.pinimg.com/736x/0f/a2/96/0fa2960093b1f305e0235541f3084bc3.jpg',
      gallery: [
        'https://i.pinimg.com/736x/60/c5/54/60c554ca000acd8223bca753ca9cad28.jpg',
        'https://i.pinimg.com/736x/a8/06/75/a806753a84cb835b12f319918e97647e.jpg',
        'https://i.pinimg.com/736x/0f/a2/96/0fa2960093b1f305e0235541f3084bc3.jpg',
      ],
    },
    alt: 'Porsche 911 PPF ja keraamiline kaitse enne ja pärast',
    metaTitle: 'Porsche 911 premium-kaitse – PPF Garage',
    metaDescription:
      'Porsche 911 täiskate PPF koos keraamilise kaitsega. Maksimaalne autokaitse ja intensiivne läige.',
    keywords: ['Porsche 911', 'PPF', 'keraamiline kaitse', 'premium'],
    serviceLink: '/teenused/kaitsekiletamine-ppf',
    ctaLink: '/kontakt?service=ppf',
    ctaFormLink: '/kontakt?service=ppf',
    tags: ['PPF', 'Porsche', 'keraamiline kaitse', 'premium'],
    year: 2024,
    publishedDate: '2025-09-05',
    clientName: 'Porsche 911 omanik',
  },
  {
    id: 'tesla-model-3-keraamika',
    slug: 'tesla-model-3-keraamika',
    title: 'Tesla Model 3 – keraamiline kaitse',
    category: 'ceramic',
    shortDescription:
      'Tesla Model 3 keraamiline kaitse, mis säilitab auto musta läike ja vähendab igapäevase mustuse nähtavust.',
    description:
      'Tesla Model 3 sai kaitsekihti, mis hoiab selle musta kere sätendavana ja lihtsustab hooldust.',
    fullDescription:
      '<p>Tesla Model 3 omanik soovis lisada keraamilist kaitset, mis muudab auto pinnapinna vastupidavamaks ja kergemini puhastatavaks. Paigaldasime vastupidava CarPro Quartz filmi, mis hoiab auto nägusana ning kaitseb väikeste kriimustuste eest.</p><p>Keraamiline kaitse parandab hüdrofoobset mõju ning kergendab autopesu. Lisaks annab see pinnale sügava ja ühtlase sära.</p><p>Tulemus: Tesla püsib läikiv ja kaitstud aastaringse Eesti ilma eest.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/56/43/91/5643910e2651ba6097630e5776bfcad0.jpg',
      after: 'https://i.pinimg.com/736x/2e/8b/60/2e8b60c67ca54bc6ec71e5796fade473.jpg',
      gallery: [
        'https://i.pinimg.com/1200x/ee/84/8e/ee848e43bc9c9887c92f336dbfbf8a5f.jpg',
        'https://i.pinimg.com/1200x/e9/03/b3/e903b3c608f0a221a0cc6735909da74f.jpg',
        'https://i.pinimg.com/736x/0f/a2/96/0fa2960093b1f305e0235541f3084bc3.jpg'
      ],
    },
    alt: 'Tesla Model 3 keraamiline kaitse enne ja pärast',
    metaTitle: 'Tesla Model 3 keraamiline kaitse – näide | PPF Garage',
    metaDescription:
      'Tesla Model 3 keraamiline kaitse tagab sügava läike ja kergema hoolduse. Kaitseb musta kere kriimustuste eest.',
    keywords: ['Tesla Model 3', 'keraamiline kaitse', 'must läige', 'CarPro Quartz'],
    serviceLink: '/teenused/keraamiline-kaitse',
    ctaLink: '/kontakt?service=ceramic',
    ctaFormLink: '/kontakt?service=ceramic',
    tags: ['keraamiline kaitse', 'Tesla', 'Model 3', 'läige'],
    year: 2024,
    publishedDate: '2025-09-20',
    clientName: 'Tesla Model 3 omanik',
  },
  {
    id: 'range-rover-sport-toonimine',
    slug: 'range-rover-sport-toonimine',
    title: 'Range Rover Sport – klaaside toonimine',
    category: 'tinting',
    shortDescription:
      'Range Rover Sportile professionaalne klaaside toonimine, mis lisab agressiivse välimuse ja privaatsuse.',
    description:
      'Klaaside toonimine Range Rover Sportile annab luksusliku väljanägemise ja vähendab kuumenemist salongis.',
    fullDescription:
      '<p>Range Rover Sport sai tumedamad klaasid, mis annavad autole agressiivse ja luksusliku iseloomu. Paigaldasime kvaliteetse kilet, mis ümardab auto välimust ja kaitseb UV-kiirguse eest.</p><p>Klaaside toonimine suurendab privaatsust ning pikendab salongi sisustuse eluiga, vähendades päikesepõletust ja kuumenemist.</p><p>Tulemus: Range Rover Sport näeb välja tugev, stiilne ja hästi kaitstud.</p>',
    images: {
      before: 'https://i.pinimg.com/736x/1e/9d/3c/1e9d3c02b2987535f7347ad8d42bfbfa.jpg',
      after: 'https://i.pinimg.com/736x/c6/b1/86/c6b1864a4e8e5dffabea161a63a29158.jpg',
      gallery: [
        'https://i.pinimg.com/736x/24/08/ad/2408ad345685d2916699490467752ba3.jpg',
        'https://i.pinimg.com/736x/7a/85/69/7a856919bc9ce70016bdfcc4b660f785.jpg',
        'https://i.pinimg.com/736x/0f/a2/96/0fa2960093b1f305e0235541f3084bc3.jpg',
      ],
    },
    alt: 'Range Rover Sport klaaside toonimine enne ja pärast',
    metaTitle: 'Range Rover Sport klaaside toonimine – PPF Garage',
    metaDescription:
      'Range Rover Sport klaaside toonimine lisab privaatsust, kaitseb UV-kiirguse eest ja loob luksusliku välimuse.',
    keywords: ['Range Rover Sport', 'klaaside toonimine', 'UV-kaitse', 'privaatsus'],
    serviceLink: '/teenused/klaaside-toonimine',
    ctaLink: '/kontakt?service=tinting',
    ctaFormLink: '/kontakt?service=tinting',
    tags: ['toonimine', 'Range Rover', 'SUV', 'privaatsus'],
    year: 2024,
    publishedDate: '2025-10-05',
    clientName: 'Range Rover Sport omanik',
  },
];

export function findProjectBySlug(slug: string) {
  return projects.find((project) => project.slug === slug);
}

export const categoryLabels: Record<'ppf' | 'ceramic' | 'tinting', string> = {
  ppf: 'PPF kiletamine',
  ceramic: 'Keraamiline kaitse',
  tinting: 'Klaaside toonimine',
};

export const categoryDescriptions: Record<'ppf' | 'ceramic' | 'tinting', string> = {
  ppf: 'Paint Protection Film – nähtamatu kaitsekile, mis kaitseb auto UV-kiirte, kivitäkete ja soolapiiskade eest.',
  ceramic: 'Keraamiline kaitsekiht, mis annab sügava läike ning kaitse veest ja kemikaalidest.',
  tinting: 'Klaaside toonimine, mis parandab privaatsust ja kaitseb UV-kiirguse eest.',
};
